import { formatApiDateRangeDisplay } from '#/utils/date';

/**
 * UI range DatePicker ↔ listQuery.filters（API：`planned_ship_date_from`／`_to`）。
 */
export function readPlannedShipDateRangeFilter(filters = {}) {
  const from = filters.plannedShipDateFrom;
  const to = filters.plannedShipDateTo;

  if (!from && !to) {
    return undefined;
  }

  return {
    from: from ?? '',
    to: to ?? from ?? '',
  };
}

export function applyPlannedShipDateRangeToFilters(filters = {}, range) {
  const next = { ...filters };

  if (!range?.from && !range?.to) {
    delete next.plannedShipDateFrom;
    delete next.plannedShipDateTo;
    return next;
  }

  const from = range.from;
  const to = range.to || range.from;

  next.plannedShipDateFrom = from || undefined;
  next.plannedShipDateTo = to || undefined;

  return next;
}

export function resolvePlannedShipDateFilterChipDisplay(_values, ctx = {}) {
  const display = formatApiDateRangeDisplay({
    from: ctx.filters?.plannedShipDateFrom,
    to: ctx.filters?.plannedShipDateTo,
  });

  return display ? [display] : [];
}
